<header class="public-layout-header">
  <div class="d-flex align-items-center">
    <a href="#" class="logo-wrapper"><img src="/img/telq-logo.png" alt="Telq" /></a>
    <h1 class="display-4 header-title">TelQ Testing Platform</h1>
  </div>
</header>
